<template>
<div style="position:relative">
    <a :class="['cbd-follow-btn', className]" @click.prevent="handleClick">{{text}}</a>
    <!-- 取消订阅遮罩 -->
    <div v-if="showCancelMask" class="mask">
        <div class="dialog-c">
            <div class="question">确定要取消订阅吗?</div>
            <div class="btn-group">
                <div class="item left" @click.prevent.stop="handleOK">确认取消</div>
                <div class="item right" @click.prevent.stop="handleCancel">我再想想</div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { MessageBox } from "./MessageBox/src/main.js"
import CookieUtil from "../../../src/utils/cookie"
import Util from "../../../src/utils/util.js"
import Supporter from "../../../src/utils/supporter"

const HOST = Util.getUsApiHost()
const LOGINPAGEHOST = Util.getLoginPageHost()
const spmDCode = 'subscribe'
export default {
    name: 'FollowBtn',
    props: {
        // 记住页面状态在登录回跳后进行提示
        isRemberFollowState: {
            type: Boolean,
            default: false
        },
        // 订阅/不订阅的值
        value: {
            type: Boolean,
            default: undefined
        },
        // 被订阅用户的id
        followAccountId: {
            type: [Number, String],
            default: undefined
        },
        // 来源 header-导航
        from: {
            type: String,
            default: 'article'
        },
        // 被订阅用户的类型 0-搜狐号用户 1-普通用户 一般都是搜狐号用户
        followUserType: {
            type: [Number, String],
            default: 0
        },
        // 当前用户的用户信息，不传递认为未登录
        userInfo: {
            type: Object,
            default: null
        },
        // 按钮显示的关键词
        keyWord: {
            type: String,
            default: '订阅'
        },
        // 点击上报码
        clickCode: {
            type: Number,
            default: () => {
                return 9991
            }
        },
        spmCCode: {
            type: String,
            default: () => {
                return ''
            }
        },
    },
    data () {
        return {
            isMSOHU: Supporter.isMSOHU,
            isFollowMap: {
                // 已订阅
                true: {
                    class: 'no-follow',
                    text: `已${this.keyWord}`,
                    api: `${HOST}/api/follow`
                },
                headerTrue: {
                    class: 'header-followd',
                    text: ``,
                    api: `${HOST}/api/follow`
                },
                // 未订阅
                false: {
                    class: '',
                    text: `+${this.keyWord}`,
                    api: `${HOST}/api/follow/unfollow`
                }
            },
            isFollow: this.value || false,
            cookieKey: 'sohu-follow',
            isRequesting: false,
            showCancelMask: false, // 是否展示取消订阅对话框
            isShowSuccess: false, //展示订阅成功气泡
            isFromHeader: false, //确定是从哪里触发的订阅，true为从header上 false为点击订阅按钮
        }
    },
    mounted () {
        // 判断是否已订阅此用户
        if (this.value === undefined) {
            this.isFollowBatchApi(this.followAccountId, res=> {
                this.isFollow = !!(res.data && res.data[this.followAccountId])
                this.$emit('update-follow-status',this.isFollow)
            }, err => {})
        }
    },
    computed: {
        fromHeader() {
            return this.from == 'header'
        },
        className () {
            if(this.fromHeader && this.isFollow) {
                return this.isFollowMap['headerTrue'].class
            }
            return this.isFollowMap[this.isFollow].class
        },
        text () {
            if(this.fromHeader && this.isFollow) {
                return this.isFollowMap['headerTrue'].text
            }
            return this.isFollowMap[this.isFollow].text
        }
     },
    methods: {
        handleClick () {
            if(!this.isFollow)this.followApi()
            else {
                let clkParam = `authorId:${this.followAccountId};type:author;location:${this.isFromHeader?'db':'zhb'}`
                this.burryCode(9874,clkParam)
                this.showCancelMask = true // 取消订阅时，弹出对话框
            }
            
        },
        // 取消“取消订阅”
        handleCancel() {
            this.showCancelMask = false
            this.burryCode(10080)
        },
        // 确认“取消订阅”
        handleOK() {
            this.followApi()
            this.showCancelMask = false
            this.burryCode(10081)
        },
        followApi (flag) {
            if (this.isRequesting) return
            if (this.isMSOHU && window.Panther && typeof window.Panther.changeMPFollowStatus === 'function') {
                this.followApiAPP(flag)
            } else {
                this.followApiH5(flag)
            }
        },
        followApiH5 (flag) {
            // 未登录
            if (!this.userInfo) {
                this.toLogin()
                return;
            }
            // 登录情况下点击订阅按钮事件
            if(this.clickCode && !this.isFollow) {
                let clkParam = `authorId:${this.followAccountId};type:author;location:${this.isFromHeader?'db':'zhb'}`
                this.burryCode(this.clickCode,clkParam)

            }
            let apiF = flag === undefined ? !this.isFollow : flag
            let params = {
                followingAccountId: this.followAccountId,
                followingUserType : this.followUserType,
                userType: this.userInfo.userType
            }
            this.isRequesting = true
            $.ajax({
                url: this.isFollowMap[apiF].api,
                type: 'POST',
                data: params,
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                success: (res) => {
                    if (res && res.data) {
                        this.isFollow = apiF
                        this.$emit('update-follow-status',this.isFollow)
                        if(apiF) {
                            this.$emit('show-follow-entry')
                            this.showSuccessDialog()
                        }
                        // 取消订阅单框
                        if(!apiF){
                            MessageBox.$toast({
                                title: `已取消${this.keyWord}`,
                            })
                        }
                        this.sendAction(1, apiF)
                    } else if (res && res.code === 408) {
                        this.toLogin()
                    } else {
                        MessageBox.$toast({
                            title: '操作失败，请稍后再试',
                        })
                    }
                    this.isRequesting = false
                },
                error: () => {
                    MessageBox.$toast({
                        title: '操作失败，请稍后再试',
                    })
                    this.sendAction(0, apiF)
                    this.isRequesting = false
                }
            })
        },
        showSuccessDialog() {
            if(document.querySelector("#headerFollowAuthor")){
                this.isFromHeader = true
            }else{
                this.isFromHeader = false
            }
            this.isShowSuccess = true //订阅成功，展示气泡
            setTimeout(()=>{
                this.isShowSuccess = false
            },2000) // 3秒后关闭气泡
        },
        followApiAPP (flag) {
            let apiF = flag === undefined ? !this.isFollow : flag
            window.Panther.changeMPFollowStatus(this.followAccountId + '', apiF).then(res => {
                if (res) {
                    this.isFollow = apiF
                    MessageBox.$toast({
                        title: apiF ? `${this.keyWord}成功` : `已取消${this.keyWord}`,
                    })
                    this.sendAction(1, apiF)
                } else {
                    MessageBox.$toast({
                        title: '操作失败，请稍后再试',
                    })
                    this.sendAction(0, apiF)
                }
                this.isRequesting = false
            })
        },
        toLogin () {
            this.isRemberFollowState && CookieUtil.set(this.cookieKey, this.followAccountId)
            var spmCode = window && window.sohuSpm && window.sohuSpm.getCodes && window.sohuSpm.getCodes()
            var spm = `${spmCode && spmCode.a}.${spmCode && spmCode.b}.${this.spmCCode}.${spmDCode}.${spmCode && spmCode.e}`
            const loginUrl = Util.addQueryArgs(
                `${LOGINPAGEHOST}/login`,
                {
                    r: window.location.href,
                    spm: spm,
                    origin: 3, // 订阅来源类型为3
                }
            )
            window.location.href = loginUrl
        },
        initTipPage () {
            let cookievalue = CookieUtil.get(this.cookieKey)
            if ( this.followAccountId === cookievalue && this.userInfo) {
                MessageBox.$toast({
                    title: '登录成功',
                    timeout: 1000,
                }, () => {})
                this.followApi(true)
                CookieUtil.remove(this.cookieKey)
            }
        },
        sendAction (state, apiF, codeNumber) {//true:订阅成功
            var successCode = 8582
            var failCode = 8583
            const acode = codeNumber ? codeNumber : (apiF ? successCode : failCode)
            let passport = (this.userInfo && this.userInfo.passport)
            let userId = (this.userInfo && this.userInfo.userId)
            if(window.sohuSpm && typeof window.sohuSpm.sendAction === 'function') {
                window.sohuSpm.sendAction({
                    acode: acode,
                    clkParam: `authorId:${this.followAccountId};type:author;location:${this.isFromHeader?'db':'zhb'};userId:${userId};passport:${passport};timeStamp:${new Date().getTime()};state:${state}`
                });
            }
        },
        isFollowBatchApi (followingIds, successFn, errFn) {
            $.ajax({
                url: `${HOST}/api/follow/check/batch`,
                data: {
                    followingIds,
                },
                xhrFields: {
                    withCredentials: true
                },
                success: (res) => {
                    if (typeof successFn === 'function') {
                        successFn(res)
                    }
                },
                error: err => {
                    if (typeof errFn === 'function') {
                        errFn(err)
                    }
                }
            })
        },
        burryCode(acode,clkParam=''){
            if(window.sohuSpm && typeof window.sohuSpm.sendAction === 'function') {
                window.sohuSpm.sendAction({
                    acode: acode,
                    clkParam
                });
            }
        }
    },
    watch: {
        value (val, oldVal) {
            this.isFollow = val
        }
    }
}
</script>

<style lang="less" scoped>
    .cbd-follow-btn {
        display: flex;
        padding: 12px 20px;
        line-height: 1;
        font-size: 24px; /* px */
        font-weight: bold;
        background: #ffd200;
        color: #000000;
        text-align: center;
        align-items: center;
        justify-content: center;

        &.no-follow {
            background: #F8F8F8;
            color: #999999;
        }
        &.header-followd {
            width: 40px;/* px */
            height: 40px;/* px */
            background: url('//statics.itc.cn/WAP_base/icon_subscription_empty4@2x.png');
            background-size: 100% 100%;
            padding: 0;
        }
    }
    .mask {
        position: fixed;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        z-index: 1001;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        .dialog-c {
            width: 560px;
            height: 336px;
            background: #FFFFFF;
            border-radius: 8px;
            padding: 64px 64px 48px;
            box-sizing: border-box;
            .question {
                width: 432px;
                height: 88px;
                font-size: 32px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #111111;
                line-height:88px;
                text-align: center;
            }
            .btn-group {
                width: 432px;
                height: 72px;
                border-radius: 4px;
                margin-top: 64px;
                display: flex;
                justify-content: space-between;
                .item {
                    width: 208px;
                    height: 72px;
                    line-height: 72px;
                    background: #F2F2F2;
                    border-radius: 4px;
                    font-weight: 500;
                    text-align: center;
                    font-size: 28px;
                }
                .left {
                    color: #F43640;
                    
                }
                .right {
                    color: #111111;
                }
            }
        }
    }
.follow-success-c {
    z-index: 1;
    width: 456px;
    height: 88px;
    background: url('https://statics.itc.cn/WAP_base/balloon.png') no-repeat;
    background-size: 100%;
    padding-top: 34px;
    padding-left: 24px;
    box-sizing: border-box;
    box-shadow: 0px 8px 20px -4px rgba(0,0,0,0.07);
    .content{
        display: flex;
        height: 40px;
        align-items: center;
        .img-c {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background: white;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 16px;
            img {
                width: 22.8px;
                height: 22.8px;
                }
        }
        .follow-txt{
            height: 40px;
            font-size: 28px;
            font-weight: 500;
            color: #111111;
            line-height: 40px;
        }
        .txt{
            margin-left: 20px;
            height: 32px;
            font-size: 24px;
            font-weight: 400;
            color: #666666;
            line-height: 32px;
            span:nth-child(2) {
                margin-left: 6px;
                margin-right: 6px;
                font-weight: 500;
            }
        }

    }
}
.success-dialog-position{
    position: absolute;
    left: -326px;
}
.success-dialog-position-fixed{
        position: fixed;
        left: 270px;
        top: 88px;
}
</style>
